/**
 * Main module
 *
 * @type {angular.Module}
 */
const module = angular.module("app", ['ngTouch', 'ui.router', 'angularMoment', 'ngLodash', 'ngMap', 'rzModule', 'ngMessages', 'angularFileUpload', '720kb.tooltips', '720kb.datepicker', 'youtube-embed', 'duScroll', 'ngFileSaver', 'ngCookies']);

/**
 * Main module configuration
 */
module.config(function ($urlRouterProvider, $locationProvider, $urlMatcherFactoryProvider, $httpProvider) {
    'use strict';

    $locationProvider.html5Mode(true);
    $urlRouterProvider
        .when('', '/')
        .when('/admin/', '/admin')
        .otherwise('/404');
    $urlMatcherFactoryProvider.strictMode(false);

    // Redirect to maintenance page on 503 error
    $httpProvider.interceptors.push(function($q) {
        return {
            responseError: function(rejection) {
                if (rejection.status === 503 && rejection.headers('content-type').match(/text\/plain/)) {
                    location.href = '/maintenance.html';
                }

                return $q.reject(rejection);
            }
        };
    });
});

/**
 * Main module runtime
 */
module.run(function ($q, $rootScope, $timeout, drupal, $window, $location, $state, headermanager, moment, lodash, profile, $http, $filter, cookiesconsent, cart) {
    'use strict';

    // expose configuration
    $rootScope.config = {
        released: null,
        language: 'fr',
        site: {},
        global: {}
    };
    // when language is retrieved, fetch user & enabled headermanager translation
    profile.claim().finally(function () {
        headermanager.setLanguage();
    })

    // get website config
    $rootScope.config.released = drupal.getConfig('config_site').then(function (config) {
        angular.merge($rootScope.config, {
            site: config
        });

        // set GA config
        if (config.analytics && config.analytics.api) {
            if($window.ga) {
                $window.ga('create', config.analytics.api, 'auto');
                $window.ga('require', 'ecommerce');
                // register first page view
                $window.ga('send', 'pageview');
            }
        }

        $rootScope.config.traductionMessage = {
            it: config.popin_translation.message_it,
            en: config.popin_translation.message_en
        }

        drupal.getNationalities().then(function(nationalities) {
            angular.merge($rootScope.config.site, {
                nationality: nationalities
            });
        });

        if ($rootScope.config.site.cookies) {
            cookiesconsent.ask($rootScope.config.site.cookies.message.value);
        }

        // push header configuration
        if (config.header && config.header.parent) {
            headermanager.setMenus(config.header.parent, config.mobile_header);
        }

        if (config.cart_messages && config.cart_messages.cart_duration) {
            cart.expiration_delay = parseInt(config.cart_messages.cart_duration);
        }

        // TODO: remove mock config when it while be available through API
        angular.merge($rootScope.config.site, {
            supervisedInternshipsTitle: 'Titre par défaut',
            supervisedInternshipsDesc: 'Liste filtrée des stages à encadrer',
        });

    }).catch(function () { /* an error occured */ });

    // get default config
    drupal.getConfig('config_global').then(function (config) {
        angular.merge($rootScope.config, {
            global: config
        });
    }).catch(function () { /* an error occured */ });

    $rootScope.$on("$viewContentLoaded", function () {
        document.body.scrollTop = 0;
    });

    // state change error handler
    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
        switch(error.status) {
            case 'ACCOUNT_CHANGE_PASSWORD_INVALID_TOKEN':
                $state.go('userforgot', {errorMessage: $filter('translate')('account.tokenError')});
                break;
            case 'INTERNSHIP_SUPERVISION_UNKNOWN':
                $state.go('member.supervision.list', {errorMessage: $filter('translate')('common.unauthorizedAccess')});
                break;
            case 'ACCOUNT_LOGIN__DISCONNECT':
                profile.dismiss().finally(function () {
                    // $state.go('homepage');
                    // full page reload to change liveagent context
                    $window.location.href = $state.href('homepage');
                });
                break;
            case 'ACCOUNT_LOGIN__ADMIN':
                $window.location.href = '/admin/';
                break;
            case 'ACCOUNT_LOGIN__ALREADY':
                $state.go('member.home');
                break;
            case 'ACCOUNT_LOGIN__REDIRECT':
                $state.go('login');
                break;
            case 'ACCOUNT_LOGIN__ERROR':
                $state.go('login', {errorMessage: $filter('translate')('server.notResponding')});
                break;
            case 'ORDER_CART_EMPTY':
                $state.go('cart');
                break;
            case 'ORDER_CART__MISSING_CONFIG':
                $ste.go('cart');
                break;
            case 'ORDER_LOGIN__MISSING_INFO':
                $state.go('order.user', {errorMessage: $filter('translate')('form.hasErrors')});
                break;
            case 'ORDER_LOGIN__MISSING_ADDRESS':
                $state.go('order.user', {errorMessage: $filter('translate')('form.hasErrors')});
                break;
            case 'ORDER_LOGIN__ALREADY':
                $state.go('order.participants');
                break;
            case 'ORDER_LOGIN__NEEDED':
                $state.go('order.login');
                break;
            case 'ORDER_PARTICIPANTS__NO_INTERNSHIP':
                $state.go('order.payment');
                break;
            case 'ORDER_PAYMENT__MISSING_PARTICIPANTS':
                $state.go('order.participants');
                break;
            case 'ORDER_CONFIRMATION__UNAUTHORIZED':
                /* order unknown or not allowed from current user */
                $state.go('cart', {errorMessage: $filter('translate')('order.unknownOrder')});
                break;
            default:
                $state.go('404');
                break;
        }
    });

    // state change success handler
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        // expose if current page is homepage
        angular.merge($rootScope.config, {homepage: toState.name === 'homepage'});
        // close menu
        if ($rootScope.site.id === 'b2c') {
            headermanager.toggleMenu(false);
        }
        // init GA tracking
        if ($rootScope.config.site && $rootScope.config.site.analytics && $rootScope.config.site.analytics.api && $window.ga) {
            $window.ga('send', {
                hitType: 'pageview',
                page: $location.path()
            });
        }

        var uri = $location.path().replace(/^\/+|\/+$/g, '');
        if (uri.length === 0) {
            uri = 'homepage';
        }
        // page title
        if (pages) {
            for (var i = 0; i < pages.length; i++) {
                if (new RegExp(pages[i].pattern).test(uri)) {
                    $rootScope.title = pages[i].title;
                    break;
                }
            }
        }

        // Matomo tracking
        if ($window._paq) {
            $window._paq.push(['setCustomUrl', $location.path()]);
            $window._paq.push(['setDocumentTitle', $rootScope.title]);
            $window._paq.push(['trackPageView']);
        }
    });

    $rootScope.$on("$viewContentLoaded", function() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    });

    // MomentJS config for french language
    moment.updateLocale('fr', {
        months: 'Janvier_Février_Mars_Avril_Mai_Juin_Juillet_Août_Septembre_Octobre_Novembre_Décembre'.split('_'),
        monthsShort: 'janv_févr_mars_avr_mai_juin_juil_août_sept_oct_nov_déc'.split('_'),
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim_lun_mar_mer_jeu_ven_sam'.split('_'),
        weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
        weekdaysParseExact: true,
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            m: '%d minute',
            mm: '%d minutes',
            h: '%d heure',
            hh: '%d heures',
            d: '%d jour',
            dd: '%d jours',
            M: '%d mois',
            MM: '%d mois',
            y: '%d an',
            yy: '%d ans'
        }
    });
});

/**
 * Angular bootstrapping
 */
angular.element(function () {
    angular.bootstrap(document, ['app']);
});
